import React from 'react';

// PI / Group PI printed as a sales contract: the title becomes SALES CONTRACT and the
// validity lines are replaced by the shipment and expiry dates picked here.
export const SalesContractToolbar = ({ salesContract, setSalesContract }) => (
  <span style={{ marginLeft: '12px', display: 'inline-flex', alignItems: 'center', gap: '6px', fontSize: '13px' }}>
    <label style={{ display: 'inline-flex', alignItems: 'center', gap: '4px' }}>
      <input
        type="checkbox"
        checked={salesContract.on}
        onChange={(e) => setSalesContract((prev) => ({ ...prev, on: e.target.checked }))}
      />
      Sales Contract
    </label>
    {salesContract.on && (
      <>
        <span>Shipment</span>
        <input type="date" value={salesContract.shipmentDate} onChange={(e) => setSalesContract((prev) => ({ ...prev, shipmentDate: e.target.value }))} />
        <span>Expiry</span>
        <input type="date" value={salesContract.expiryDate} onChange={(e) => setSalesContract((prev) => ({ ...prev, expiryDate: e.target.value }))} />
      </>
    )}
  </span>
);

export const emptySalesContract = { on: false, shipmentDate: '', expiryDate: '' };

// "2026-11-30" -> "30.11.2026"; blank leaves a line to write on.
export const scDate = (value) => (value ? value.split('-').reverse().join('.') : '____________');
